import { formatReadingValue } from '@/utils/consumerColumns'

// Format a resource value for display and copying
export const formatResourceValue = (value: any, langKey: string): string => {
  if (value === null || value === undefined) return '-'
  if (Array.isArray(value)) {
    const filtered = value.filter(v => v !== null && v !== undefined && v !== '')
    return filtered.length > 0 ? filtered.join(', ') : '-'
  }
  if (typeof value === 'boolean') return langKey === 'he' ? (value ? 'כן' : 'לא') : (value ? 'Yes' : 'No')
  if (typeof value === 'object') return JSON.stringify(value)
  const str = String(value).trim().replace(/[{}]/g, '')
  return str || '-'
}

// Format a flat field value for display and copying
export const formatValue = (value: any, langKey: string, key?: string): string => {
  if (value === null || value === undefined) return '-'

  let val = value

  // Special formatting for numeric readings
  if (
    key &&
    [
      'lastValue',
      'last_value',
      'lastConsumption',
      'last_consumption',
      'rValue',
      'r_value',
      'avgWeeklyConsumption',
    ].includes(key)
  ) {
    return formatReadingValue(val)
  }

  // Special formatting for ITM coordinates
  if (key === 'itmCoordinates') {
    if (typeof val === 'string') {
      try {
        val = JSON.parse(val)
      } catch {}
    }
    if (typeof val === 'object' && val !== null) {
      const x = val.x
      const y = val.y
      if (x != null && y != null)
        return `${Number(x).toFixed(2)}, ${Number(y).toFixed(2)}`
    }
    if (typeof val === 'string') return val
    return '-'
  }

  // Special formatting for coordinates
  if (key === 'coordinates') {
    if (typeof val === 'string' && val.startsWith('{')) {
      try {
        val = JSON.parse(val)
      } catch (e) {}
    }

    if (typeof val === 'object' && val !== null) {
      const lat = val.lan ?? val.lng ?? val.latitude ?? val.second ?? val.lat
      const lng = val.lat ?? val.latitude ?? val.first ?? val.lon
      if (lat !== undefined && lng !== undefined) return `${lat},${lng}`
    }
    // Fallback for coordinates
    if (typeof val === 'string') return val
  }

  // Special formatting for Install Date
  if (key === 'installedPeriod' || key === 'installed_period') {
    const dateStr = Array.isArray(val) ? val[0] : val
    if (typeof dateStr === 'string' && dateStr.includes('-')) {
      const [yyyy, mm, dd] = dateStr.split('T')[0].split('-')
      if (yyyy && mm && dd) return `${dd}/${mm}/${yyyy}`
    }
  }

  // Special formatting for Reception Date
  if (key === 'date' || key === 'lastReadingAt' || key === 'קליטה') {
    const dateStr = String(val)
    if (dateStr.includes('T') || dateStr.includes('-')) {
      try {
        const d = new Date(dateStr)
        if (!isNaN(d.getTime())) {
          const dd = String(d.getDate()).padStart(2, '0')
          const mm = String(d.getMonth() + 1).padStart(2, '0')
          const yyyy = d.getFullYear()
          const hours = String(d.getHours()).padStart(2, '0')
          const minutes = String(d.getMinutes()).padStart(2, '0')
          return `${dd}/${mm}/${yyyy} ${hours}:${minutes}`
        }
      } catch (e) {}
    }
  }

  // Generic formatting for Arrays
  if (Array.isArray(val)) {
    const filtered = val.filter(v => v !== null && v !== undefined && v !== '')
    return filtered.length > 0 ? filtered.join(', ') : '-'
  }

  if (typeof value === 'boolean')
    return langKey === 'he' ? (value ? 'כן' : 'לא') : value ? 'Yes' : 'No'
  if (typeof value === 'object') {
    return JSON.stringify(value)
  }
  const str = String(value).trim()
  return str || '-'
}
